export default __webpack_public_path__ + "static/media/imageSix.da020d96.png";